/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Audio_Embed_Export_Ad_Streams_HeadingInputs */



/**
* | output |
* | --- |
* | "AD streams" |
*
* @param {Audio_Embed_Export_Ad_Streams_HeadingInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const audio_embed_export_ad_streams_heading = /** @type {((inputs?: Audio_Embed_Export_Ad_Streams_HeadingInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audio_Embed_Export_Ad_Streams_HeadingInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Flux publicitaires")
	if (locale === "de") return /** @type {LocalizedString} */ ("AD-Streams")
	if (locale === "it") return /** @type {LocalizedString} */ ("Flussi pubblicitari")
	if (locale === "ru") return /** @type {LocalizedString} */ ("AD-потоки")
	if (locale === "es") return /** @type {LocalizedString} */ ("transmisiones de anuncios")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("AD流")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ADストリーム")
	if (locale === "hi") return /** @type {LocalizedString} */ ("एडी स्ट्रीम")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Fluxos de anúncios")
	return /** @type {LocalizedString} */ ("AD streams")
});